import React, { Component } from 'react';
import Modal from './Modal.index';
import { FormattedMessage } from 'react-intl';

export default class AllEntitiesFromCategoryModal extends Component {

    render() {

        return (
            <div id={this.props.modalName} className='see-all-entities-modal'>

                <Modal closeButtonHandler={this.props.isModalLoading ? null : this.props.secondaryAction}
                       buttons={
                           [
                               {
                                   text:       <FormattedMessage
                                                   id={this.props.secondaryI18n ? this.props.secondaryI18n :
                                                       "General_CoreFunctionality_UIText_general.ok"} />,
                                   isDisabled: this.props.isModalLoading,
                                   click:      this.props.secondaryAction,
                                   tabIndex:   1
                               }
                           ]
                       }>

                    <div>
                        <h2 className="modal-header">{this.props.title}</h2>
                        <div className="divider"></div>
                        <div className='modal-body-container'>
                            {this.props.children}
                        </div>
                    </div>

                </Modal>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Modal/AllEntitiesFromCategoryModal.jsx